import '@mantine/core/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './index.css';

import { MantineProvider, createTheme } from '@mantine/core';
import App from './App';
import About from './pages/about';
import { Goy } from './pages/goy';
import Home from './pages/home';
import Info from './pages/info';
import Schedule from './pages/schedule';
import Seasons from './pages/seasons';
import reportWebVitals from './reportWebVitals';
import MapPage from './pages/map';


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <Home />,
      }, {
        path: "about",
        element: <About />,
      },
      {
        path: "info",
        element: <Info />,
      },
      {
        path: "seasons",
        element: <Seasons />
      },
      {
        path: "schedule",
        element: <Schedule />,
      },
      {
        path: "goy",
        element: <Goy />,
      },
      {
        path: "map",
        element: <MapPage />,
      }
    ]
  }
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = createTheme({
  /** Put your mantine theme override here */
  primaryColor: 'cyan',
});

root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <RouterProvider router={router} ></RouterProvider>
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
